import {
  Component,
  ComponentInterface,
  Event,
  EventEmitter,
  Fragment,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-toggle-radio.scss',
  tag: 'paf-toggle-radio',
})

export class PafToggleRadio implements ComponentInterface {

  /**
   * The name attribute to use for the input elements
   */
  @Prop() public optionsName!: string;

  /**
   * The value of the input element which should be checked initially
   */
  @Prop() public checkedValue!: string;

  /**
   * The value of the first input
   */
  @Prop() public option1value!: string;

  /**
   * The label of the first input
   */
  @Prop() public option1label!: string;

  /**
   * The value of the second input
   */
  @Prop() public option2value!: string;

  /**
   * The label of the second input
   */
  @Prop() public option2label!: string;

  /**
   * The text for the hidden legend
   */
  @Prop() public legend?: string;

  /**
   * Event which is emitted when the value of the toggle changes
   */
  @Event({
    bubbles: true,
    composed: true,
    eventName: 'paf-toggle-radio_changed',
  })
  public changed: EventEmitter<string>;

  private _onChange = (evt): void => {
    evt.preventDefault();
    evt.stopPropagation();

    this.changed.emit(evt.target.value);
  };

  public render(): HTMLDivElement {
    const options = [
      {
        label: this.option1label,
        value: this.option1value,
      },
      {
        label: this.option2label,
        value: this.option2value,
      },
    ];

    return (
      <fieldset class='toggle-radio'>

        {this.legend &&
          <legend
            class='legend'
            data-testid='legend'
          >
            {this.legend}
          </legend>
        }

        {options.map((option, index) => (
          <Fragment>
            <input
              onChange={this._onChange}
              class='input'
              type='radio'
              id={option.value}
              name={this.optionsName}
              value={option.value}
              checked={this.checkedValue === option.value}
              data-testid={`option-${index}`}
            />
            <label
              class='label'
              htmlFor={option.value}
              data-testid={`label-${index}`}
            >
              {option.label}
            </label>
          </Fragment>
        ))}
      </fieldset>
    );
  }
}
